/**
 * Constantes y helpers de la pestaña de asistencia. Fuera de los módulos de
 * componentes por `react-refresh` (§2.3).
 *
 * Estas listas son de PRESENTACIÓN: la verdad sobre qué se puede impactar la
 * decide el back en `admiteImpacto` y `accionesRequeridas`. Acá solo se usan
 * para agrupar y para decidir qué formulario mostrar.
 */

import type { JornadaDto } from '../../api';

/** Clave estable de una jornada: la identifica en la selección y el detalle. */
export const claveDe = (j: JornadaDto): string => `${j.dni}|${j.fechaOperativa}`;

/** Estados que todavía esperan que el proceso los impacte. */
export const PENDIENTES: readonly string[] = ['ASISTENCIA_AL_VIAJE', 'SIN_TAREA'];

/** Estados que requieren intervención del supervisor. */
export const A_RESOLVER: readonly string[] = [
  'SIN_TURNO_CONFIGURADO',
  'VIAJE_SIN_FICHADA',
  'LICENCIA_A_CORREGIR',
];

/**
 * Agrupación visual de estados. El color del riel de la fila y el del card de
 * estado del detalle salen de acá.
 *
 * Es de PRESENTACIÓN, como el resto del archivo: el back no la conoce y no
 * hace falta que la conozca — agrupa los mismos estados que él ya informa.
 */
export function grupoDe(estado: string): 'pendiente' | 'listo' | 'revisar' | 'espera' {
  if (estado === 'IMPACTADA' || estado === 'RESUELTA_POR_SUPERVISOR') return 'listo';
  if (PENDIENTES.includes(estado)) return 'pendiente';
  /*
   * Esperando viaje no es un problema ni algo para hacer: es una jornada que
   * todavía no se puede decidir. Pintarla de rojo junto a las que necesitan
   * intervención haría que alguien la vaya a mirar todos los días al pedo.
   */
  if (estado === 'ESPERANDO_VIAJE') return 'espera';
  return 'revisar';
}
